export const CARD_ANIMATION_SECONDS = 2;
export const COLLAB_COMPLETE_ANIMATION_SECONDS = 5;
